/** Tokens visuais — marcas loja (marca TNV) */
export const MARCAS_ACCENT = "#F96030";
export const MARCAS_INK = "#1a2035";

export const marcasToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${MARCAS_ACCENT}`,
};

export const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
  },
};

export const statusToggleSx = {
  flexWrap: "wrap" as const,
  "& .MuiToggleButton-root": {
    px: 1.25,
    py: 0.75,
    textTransform: "none" as const,
    fontSize: "0.8125rem",
    "&.Mui-selected": {
      bgcolor: "rgba(249, 96, 48, 0.1)",
      borderColor: MARCAS_ACCENT,
      color: MARCAS_ACCENT,
      fontWeight: 600,
    },
  },
};

export const emptyStateSx = {
  py: 6,
  textAlign: "center",
  border: "1px dashed",
  borderColor: "grey.300",
  borderRadius: 2,
  bgcolor: "grey.50",
};

export const saveButtonSx = {
  background: `linear-gradient(195deg, ${MARCAS_ACCENT}, #e04a1a)`,
};

export const modalPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  maxHeight: "92vh",
  display: "flex",
  flexDirection: "column" as const,
  width: { xs: "100%", sm: "96vw" },
  maxWidth: 520,
};

export const modalHeaderSx = {
  px: 3,
  py: 2.5,
  flexShrink: 0,
  background: `linear-gradient(135deg, ${MARCAS_INK} 0%, #2d3561 100%)`,
  color: "#fff",
  borderBottom: `3px solid ${MARCAS_ACCENT}`,
};

export const gridSx = {
  minHeight: 420,
  "& .MuiDataGrid-cell": {
    display: "flex",
    alignItems: "center",
  },
};

export const actionIconSx = {
  color: MARCAS_ACCENT,
  "&:hover": { bgcolor: "rgba(249, 96, 48, 0.08)" },
};

export const switchSx = {
  "& .MuiSwitch-switchBase.Mui-checked": { color: MARCAS_ACCENT },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    bgcolor: `${MARCAS_ACCENT} !important`,
  },
};
